<template>
  <LearnGuidePage :page="page" />
</template>

<script setup>
// One generated module per guide (modules/page-data.ts), so a page downloads only its own.
import learnLoaders from '#build/page-data/learn-loaders.mjs';

const route = useRoute();
const page = await learnLoaders[route.params.slug]?.();

if (!page) {
  throw createError({ statusCode: 404, statusMessage: 'Guide not found' });
}
</script>
